import * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as dynamicEcs from '../../../../../dynamic-ecs'
import type { Plugin } from '../plugin'

/**
 * Triggers bootstrap action when a table widget renders successfully.
 */
export const triggerEcBootstrap = store.effects.create(
  (feature: Plugin['feature'], dynamicEcsFeature: dynamicEcs.Feature) =>
    feature.actions.preview.success.observe().pipe(
      rxjs.map(
        ({
          data: {
            request: { flexibleIdentifier, refId },
            response: { preview },
          },
        }) => {
          // NOTE: we might as well at least try and see if it works
          const rendering = preview as ents.core.mosaic.Widget.Rendering

          return rendering.type === ents.core.mosaic.Widget.Type.Table
            ? dynamicEcsFeature.actions.bootstrap
                .from('triggerBootstrap (effect)')
                .create({
                  ref: {
                    id: refId,
                    widget: flexibleIdentifier,
                  },
                  rendering,
                })
            : store.effects.SKIP
        },
      ),
    ),
)
